import { showError, showInfo } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';
import {
    shouldFetchSuperSimSponsoredNews,
    SUPERSIM_SPONSORED_NEWS_ID,
    withSuperSimSponsoredNewsAssets,
    withSuperSimSponsoredNewsAssetsInList,
} from '../helpers/superSimSponsoredNews';

// ACTIONS TYPE

// NewsHomeComponent
export const SET_DATA_HOME = 'SET_DATA_HOME';
const setDataHome = (data) => ({
    type: SET_DATA_HOME,
    data,
});

// NewsHomeComponent (right column pin)
export const SET_PINNED_RIGHT_COLUMN_NEWS = 'SET_PINNED_RIGHT_COLUMN_NEWS';
const setPinnedRightColumnNews = (data) => ({
    type: SET_PINNED_RIGHT_COLUMN_NEWS,
    data,
});

// NewsPageComponent & NewsHomeComponentMobile
export const SET_DATA_PAGE = 'SET_DATA_PAGE';
const setDataPage = (data) => ({
    type: SET_DATA_PAGE,
    data,
});

export const UPDATE_NEWS_DATA = 'UPDATE_NEWS_DATA';
const updateNewsData = (data) => ({
    type: UPDATE_NEWS_DATA,
    data,
});

export const UPDATE_NEWS_FILTERED_DATA = 'UPDATE_NEWS_FILTERED_DATA';
const updateNewsFilteredData = (data) => ({
    type: UPDATE_NEWS_FILTERED_DATA,
    data,
});

// NewsPageComponent
export const SET_ISLOADING = 'SET_ISLOADING';
const setIsLoading = (isLoading) => ({
    type: SET_ISLOADING,
    isLoading,
});

export const SET_NEWS_CATEGORY = 'SET_NEWS_CATEGORY';
const setNewsCategory = (data) => ({
    type: SET_NEWS_CATEGORY,
    data,
});

export const SET_TAGS = 'SET_TAGS';
const setTags = (data) => ({
    type: SET_TAGS,
    data,
});

export const SET_NEWS_FILTERED = 'SET_NEWS_FILTERED';
const setNewsFiltered = (data) => ({
    type: SET_NEWS_FILTERED,
    data,
});

export const RESET_NEWS_FILTERED = 'RESET_NEWS_FILTERED';
const resetNewsFiltered = () => ({
    type: RESET_NEWS_FILTERED,
});

export const SET_CURRENT_CATEGORY_SLUG = 'SET_CURRENT_CATEGORY_SLUG';
const setCurrentCategorySlug = (currentCategorySlug) => ({
    type: SET_CURRENT_CATEGORY_SLUG,
    currentCategorySlug,
});

export const SET_NOTICE_TEXT = 'SET_NOTICE_TEXT';

export const setNoticeText = (noticeText) => ({
    type: SET_NOTICE_TEXT,
    noticeText,
});

// NewsPageTags
export const SET_DATA_NEWS_TAG = 'SET_DATA_NEWS_TAG';
const setDataNewsTag = (data) => ({
    type: SET_DATA_NEWS_TAG,
    data,
});

export const SET_CURRENT_TAG_SLUG = 'SET_CURRENT_TAG_SLUG';
const setCurrentTagSlug = (currentTagSlug) => ({
    type: SET_CURRENT_TAG_SLUG,
    currentTagSlug,
});

export const RESET_NEWS_DATA_TAG = 'RESET_NEWS_DATA_TAG';
const resetNewsTag = () => ({
    type: RESET_NEWS_DATA_TAG,
});

// NewsSingleComponent
export const DATA_SINGLE_NEWS = 'DATA_SINGLE_NEWS';
const setDataSingleNews = (dataSingleNews = '') => ({
    type: DATA_SINGLE_NEWS,
    dataSingleNews,
});

export const SET_DATA_MOST_READ = 'SET_DATA_MOST_READ';
const setDataNewsMostRead = (dataNewsMostRead = '') => ({
    type: SET_DATA_MOST_READ,
    dataNewsMostRead,
});

export const IS_FETCHING_NEWS_SINGLE = 'IS_FETCHING_NEWS_SINGLE';
const setIsFetching = () => ({
    type: IS_FETCHING_NEWS_SINGLE,
});

export const END_FETCHING_NEWS_SINGLE = 'END_FETCHING_NEWS_SINGLE';
const setEndFetching = (slug) => ({
    type: END_FETCHING_NEWS_SINGLE,
    slug,
});

export const SET_DATA_RELATED_NEWS = 'SET_DATA_RELATED_NEWS';
const setDataRelatedNews = (dataRelatedNews = []) => ({
    type: SET_DATA_RELATED_NEWS,
    dataRelatedNews,
});

export const SET_LAST_TAGS = 'SET_LAST_TAGS';
const setLastTags = (lastTags = '') => ({
    type: SET_LAST_TAGS,
    lastTags,
});

export const SET_NOT_FOUND = 'SET_NOT_FOUND';

export const setNotFound = (notFound) => ({
    type: SET_NOT_FOUND,
    notFound,
});

export const NEW_NEWS = 'NEW_NEWS';

export const setNewNews = (data) => ({
    type: NEW_NEWS,
    data,
});

export const NEW_NEWS_FILTERED = 'NEW_NEWS_FILTERED';

export const setNewNewsFiltered = (data) => ({
    type: NEW_NEWS_FILTERED,
    data,
});

export const UPDATE_NEWS_VOTES = 'UPDATE_NEWS_VOTES';

export const updateNewsVotes = (id, votes) => ({
    type: UPDATE_NEWS_VOTES,
    id,
    data: votes,
});

export const INSERT_NEWS_VIEW = 'INSERT_NEWS_VIEW';

export const insertNewsView = (newsView) => ({
    type: INSERT_NEWS_VIEW,
    newsView,
});

export const RESET_NEWS_VIEWS = 'RESET_NEWS_VIEWS';

export const resetNewsViews = () => ({
    type: RESET_NEWS_VIEWS,
});

// Stuff for new news tag removal

// eslint-disable-next-line padding-line-between-statements
const _removeNewNewsProperty = (dispatch, getState) => {
    // This is an internal function that clears the new news badges off of all news arrays.

    // Clean newsPageData
    const newsFromStore = getState().news.newsPageData;
    const newsClean = [];

    newsFromStore.forEach((item) => {
        const newItem = { ...item };

        if (newItem.newNews) {
            delete newItem.newNews;
        }

        newsClean.push(newItem);
    });

    // Clean Filtered News

    const newsFilteredFromStore = getState().news.newsFiltered;
    const newsnewsFilteredClean = [];

    newsFilteredFromStore.forEach((item) => {
        const newItem = { ...item };

        if (newItem.newNews) {
            delete newItem.newNews;
        }

        newsnewsFilteredClean.push(newItem);
    });

    // Clean News Home

    const newsHomeFromStore = getState().news.newsHomeData;
    const newNewsHomeClean = [];

    newsHomeFromStore.forEach((item) => {
        const newItem = { ...item };

        if (newItem.newNews) {
            delete newItem.newNews;
        }

        newNewsHomeClean.push(newItem);
    });

    Promise.all([
        dispatch(updateNewsData(newsClean)),
        dispatch(updateNewsFilteredData(newsnewsFilteredClean)),
        dispatch(setDataHome(newNewsHomeClean)),
    ])
        .then(/* console.log('cleared all news tags') */)
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.log('something went wrong when clearing the new news badges', error);
        });
};
let _updateTimerHandle = null;
const _scheduleNewNewsPropRemoval = (dispatch, getState) => {
    // Schedule the removal of the newNewsTags for 30 seconds from now
    // Cancel current timeout if there is one running already

    clearTimeout(_updateTimerHandle);

    // eslint-disable-next-line no-shadow
    _updateTimerHandle = setTimeout((dispatch, getState) => {
        _removeNewNewsProperty(dispatch, getState);
    }, 10000, dispatch, getState);
};

// get news for the newsBlocks
export const getNewsDataIfNeeded = (qtdNews, qtdInit) => (dispatch, getState) => {
    dispatch(setNoticeText(''));

    const dataPage = getState().news.newsPageData;
    const includeFeatured = qtdInit === 0;
    const includeHighlighted = qtdInit === 0;
    const init = Math.max(qtdInit, 0);
    const query = `api/v1/news/getNews/${init}/${qtdNews}/${includeFeatured}/${includeHighlighted}`;

    if (dataPage.length <= init) {
        dispatch(setIsLoading(true));

        // only get new news if the store doesn't have already the requested amount of news
        return Api.progressGet(dispatch, query)
            .then((json) => {
                dispatch(setIsLoading(false));

                if (json.status !== 'success') {
                    throw `error from server: ${json.message}`;
                } else {
                    dispatch(setCurrentCategorySlug('tudo'));

                    return dispatch(setDataPage(json.data));
                }
            }).catch((error) => {
                dispatch(setIsLoading(false));

                // eslint-disable-next-line no-console
                console.log('getNewsDataIfNeeded got error:', error);
            });
    }

    return Promise.resolve(1);
};

// newsHome Action (get 5 news of type 'featuredHome', where the first will be the latest destaque news)
export const getNewsHomeDataIfNeeded = () => (dispatch, getState) => {
    const dataHome = getState().news.newsHomeData;
    const lastUpdate = getState().news.newsHomeDataUpdated;
    const currentTime = Date.now();
    const updatePeriod = 1000 * 60 * 2; // must be at least 2 minutes between accesses
    let timeElapsed;

    if (lastUpdate) {
        timeElapsed = currentTime - lastUpdate;
    }

    if (dataHome.length === 0 || !lastUpdate || timeElapsed > updatePeriod) {
        const query = 'api/v1/news/getHomeNews/12';

        dispatch(setIsLoading(true));

        return Api.progressGet(dispatch, query)
            .then(async (json) => {
                dispatch(setIsLoading(false));

                if (json.status !== 'success') {
                    throw `error from server: ${json.message}`;
                } else {
                    let homeNewsData = withSuperSimSponsoredNewsAssetsInList(json.data);

                    if (shouldFetchSuperSimSponsoredNews(homeNewsData)) {
                        try {
                            const sponsoredNewsJson = await Api.progressGet(
                                dispatch,
                                `/api/v1/news/getNewsById/${SUPERSIM_SPONSORED_NEWS_ID}`,
                            );

                            if (sponsoredNewsJson.status === 'success' && sponsoredNewsJson.data) {
                                homeNewsData = [
                                    withSuperSimSponsoredNewsAssets(sponsoredNewsJson.data),
                                    ...homeNewsData,
                                ];
                            }
                        } catch (error) {
                            // eslint-disable-next-line no-console
                            console.log('getNewsHomeDataIfNeeded got error fetching SuperSim sponsored news:', error);
                        }
                    }

                    let hasNewNews = false;

                    if (dataHome.length > 0) {
                        // Here we will compare the old array to the new one to set the new badge on new items
                        homeNewsData.forEach((news) => {
                            // as .some() return true or false and we want to know if there is any new news
                            // we "change" its behavior negating(!) the response, so the new object (would be false)
                            // return true when not in the array

                            const newNews = !dataHome.some((element) => element.id === news.id);

                            if (newNews) {
                                // eslint-disable-next-line no-param-reassign
                                news.newNews = true;

                                hasNewNews = true;
                            }
                        });
                    }

                    if (hasNewNews) {
                        _scheduleNewNewsPropRemoval(dispatch, getState);
                    }

                    dispatch(setPinnedRightColumnNews(json.pinnedRightColumnNews));

                    return dispatch(setDataHome(homeNewsData));
                }
            }).catch((error) => {
                dispatch(setIsLoading(false));

                // eslint-disable-next-line no-console
                console.log('getNewsHomeDataIfNeeded got error:', error);
            });
    }

    return Promise.resolve(1);
};

export const getNewsCategoryIfNeeded = () => (dispatch, getState) => {
    const newsCategories = getState().news.newsCategories;

    if (newsCategories.length === 0) {
        const query = 'api/v1/news/getCategories';

        return Api.progressGet(dispatch, query)
            .then((json) => {
                if (json.status !== 'success') {
                    throw `error from server: ${json.message}`;
                } else {
                    return dispatch(setNewsCategory(json.data));
                }
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.log('getNewsCategoryIfNeeded got error:', error);
            });
    }

    return Promise.resolve(1);
};

// tag page
export const getAllTagsIfNeeded = () => (dispatch, getState) => {
    const dataTag = getState().news.dataTags;

    if (dataTag.length === 0) {
        const query = 'api/v1/news/getTags';

        return Api.progressGet(dispatch, query)
            .then((json) => {
                if (json.status !== 'success') {
                    throw `error from server: ${json.message}`;
                } else {
                    return dispatch(setTags(json.data));
                }
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.log('getAllTagsIfNeeded got error:', error);
            });
    }

    return Promise.resolve(1);
};

export const getFilteredNewsIfNeeded = (qtdNews, qtdInit, category) => (dispatch, getState) => {
    // category can either be the id or the slug!
    const includeFeatured = qtdInit === 0;
    const includeHighlighted = qtdInit === 0;
    const init = qtdInit;
    const query = `api/v1/news/getNews/${init}/${qtdNews}/${includeFeatured}/${includeHighlighted}/${category}`;
    const currentCategorySlug = getState().news.currentCategorySlug;
    const noticeText = getState().news.noticeText;

    if (category === currentCategorySlug) {
        // the category did not change, get more news
        const dataNewsFiltered = getState().news.newsFiltered;

        if (noticeText === '- - -' || dataNewsFiltered.length >= qtdInit + qtdNews) {
            // We have already arrived at the end of the news
            // Or we already have all the news we need
            return Promise.resolve(1);
        }


        if (dataNewsFiltered.length < qtdInit + qtdNews) {
            // we need more news (and do not already have all news of the given category)
            dispatch(setIsLoading(true));

            return Api.progressGet(dispatch, query)
                .then((json) => {
                    dispatch(setIsLoading(false));

                    if (json.status === 'success') {
                        if (json.data.length < qtdNews) {
                            showInfo(`Não há mais notícas sobre ${currentCategorySlug}.`);

                            return dispatch(setNoticeText('- - -'));
                        }

                        return dispatch(setNewsFiltered(json.data));
                    }

                    if (json.message === 'no news found') {
                        // this is actually 'no MORE news found'
                        showInfo('Não há mais noticias nessa categoria');

                        return dispatch(setNoticeText('- - -'));
                    }

                    throw `error from server: ${json.message}`;
                })
                .catch((error) => {
                    dispatch(setIsLoading(false));

                    // eslint-disable-next-line no-console
                    console.log('getFilteredNewsIfNeeded got error:', error);
                });
        }

        // We already got all news of this category
        showInfo('Não há mais noticias nessa categoria');

        return dispatch(setNoticeText('- - -'));
    }

    // the category changed, reset the news and query new ones (or additional ones if changed from or to tudo)
    dispatch(setNoticeText(''));

    dispatch(setCurrentCategorySlug(category));

    dispatch(resetNewsFiltered());

    dispatch(setIsLoading(true));

    return Api.progressGet(dispatch, query)
        .then((json) => {
            dispatch(setIsLoading(false));

            if (json.status === 'success') {
                return dispatch(setNewsFiltered(json.data));
            }

            if (json.message === 'no news found') {
                return dispatch(setNoticeText('Não há notícias relacionadas com a categoria.'));
            }

            throw `error from server: ${json.message}`;
        })
        .catch((error) => {
            showError('Erro na comunicação com servidor. Tente de novo mais tarde.');

            // eslint-disable-next-line no-console
            console.log('getFilteredNewsIfNeeded got error:', error);

            return dispatch(setIsLoading(false));
        });
};

// newsPageTags
export const getDataNewsByTagIfNeeded = (qtdNews, qtdInit, tag) => (dispatch, getState) => {
    const newsTagData = getState().news.newsTagData;
    const currentTagSlug = getState().news.currentTagSlug;
    const noticeText = getState().news.noticeText;
    const query = `api/v1/news/getDataNewsByTag/${qtdInit}/${qtdNews}/${tag}`;

    // get more news of the same tag
    if (currentTagSlug === tag) {
        if (noticeText || newsTagData.length === qtdInit + qtdNews) {
            return Promise.resolve(1);
        }

        if (newsTagData.length < qtdInit + qtdNews) {
            dispatch(setIsLoading(true));

            return Api.progressGet(dispatch, query)
                .then((json) => {
                    dispatch(setIsLoading(false));

                    if (json.status === 'success') {
                        if (json.data && json.data.newsArray && json.data.newsArray.length < qtdNews) {
                            showInfo(`Não há notícias sobre ${currentTagSlug}.`);

                            return dispatch(setNoticeText('- - -'));
                        }

                        return dispatch(setDataNewsTag(json.data));
                    }

                    throw `error from server: ${json.message}`;
                }).catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log('getDataNewsByTagIfNeeded got error:', error);

                    return dispatch(setIsLoading(false));
                });
        }

        showInfo(`Não há notícias sobre ${currentTagSlug}.`);

        return dispatch(setNoticeText('- - -'));
    }

    // Get news and tag meta for a new tag

    dispatch(setNoticeText(''));

    dispatch(setCurrentTagSlug(tag));

    dispatch(resetNewsTag());

    dispatch(setIsLoading(true));

    return Api.progressGet(dispatch, query)
        .then((json) => {
            dispatch(setIsLoading(false));

            if (json.status === 'success') {
                if (json.message === 'no news found' || json.message === 'tag not found') {
                    showInfo(`Não há notícias sobre ${tag}.`);

                    return dispatch(setNoticeText(`Não há notícias sobre ${tag}.`));
                }

                return dispatch(setDataNewsTag(json.data));
            }


            throw `error from server: ${json.message}`;
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log('getDataNewsByTagIfNeeded got error:', error);

            return dispatch(setIsLoading(false));
        });
};

export const fetchDataNewsMostReadIfNeeded = () => (dispatch, getState) => {
    const dataNewsMostRead = getState().news.dataNewsMostRead;

    if (dataNewsMostRead.length === 0) {
        const limitNews = 4;

        return Api.progressGet(dispatch, `/api/v1/news/getNewsMostRead/${limitNews}`).then((json) => {
            if (json.status === 'success') {
                return dispatch(setDataNewsMostRead(json.data));
            }

            throw `error from server: ${json.message}`;
        })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.log('There has been a problem with your fetch operation: ', error);
            });
    }

    return Promise.resolve(1);
};

/*
* Fetch related news based on tags.
* @param tags: List of tags ([{id, nome, slug}])
* @param limitNews: Number of related news to fetch
*/
export const fetchDataRelatedNewsIfNeeded = (tags, limitNews = 6) => (dispatch, getState) => {
    const tagSlugs = [];

    tags.map((item) => tagSlugs.push(item.slug));

    const joinedTags = tagSlugs.join('_');

    const lastTags = getState().news.lastTags;

    if (lastTags === joinedTags) {
        // We already have related news for this tags
        return false;
    }

    dispatch(setDataRelatedNews([]));

    dispatch(setLastTags());

    if (!joinedTags || joinedTags === '_') {
        // no tags given, abort
        return false;
    }

    return Api.progressGet(dispatch, `/api/v1/news/getRelatedNews/${limitNews}/${joinedTags}`).then((json) => {
        if (json.status !== 'success') {
            // Something went wrong
            return false;
        }

        dispatch(setLastTags(joinedTags));

        return dispatch(setDataRelatedNews(json.data));
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log('_fetchDataRelateNews got error: ', error);
    });
};

// newsSingle Action
/*
* Do not use this function directly, use the fetchDataSingleNewsIfNeeded() function
* more down! (however, this function CAN be used directly on the server...)
*/
export const fetchDataSingleNews = (slug, token) => (dispatch) => {
    dispatch(setNotFound(false));

    dispatch(setIsFetching());

    const url = token ? `/api/v1/news/getSingleProNews/${slug}` : `/api/v1/news/getSingleNews/${slug}`;

    return Api.progressGet(dispatch, url, token).then((json) => {
        if (json.status === 'success' && json.data) {
            const myPromises = [
                // DISPATCH MY DATA
                dispatch(setEndFetching(slug)),
                dispatch(setDataSingleNews(json.data)),
            ];

            return Promise.all(myPromises);
        }

        if (json.status === 404) {
            return Promise.all([
                dispatch(setEndFetching(slug)),
                dispatch(setNotFound(true)),
            ]);
        }

        throw `error from server: ${json.message}`;
    })
        .catch((error) => {
            dispatch(setEndFetching());

            // eslint-disable-next-line no-console
            console.log('There has been a problem with your fetch operation: ', error);
        });
};

/**
 * This will only fetch single news stuff if really needed.
 * This is useful to avoid refetching data that was already loaded on server.
 * Can also be useful to avoid refetching data on client, eg. when trying to
 * refetch news that were loaded on the last call.
 * It accepts the same parameters as fetchDataSingleNews()
 *
 * @param {String} slug the slug of the news to get the data for
 * @returns {Promise}
 */
export const fetchDataSingleNewsIfNeeded = (slug) => (dispatch, getState) => {
    const lastSlug = getState().news.lastSlug;

    if (lastSlug !== slug) {
        return dispatch(fetchDataSingleNews(slug));
    }

    return Promise.resolve(1);
};

/**
 * This will fetch the data for PRO news
 * It will NOT check if the data was already fetched (as oposed to fetchDataSingleNewsIfNeeded)
 * If no token is set, the promise will be resolved
 *
 * @param {String} slug the slug of the news to get the data for
 * @returns {Promise}
 */
export const fetchDataSingleProNews = (slug) => (dispatch, getState) => {
    const token = getState().profile.jwt;

    if (!token) {
        return Promise.resolve(1);
    }

    return dispatch(fetchDataSingleNews(slug, token));
};

export const checkForNewNews = (currentCategorySlug) => (dispatch, getState) => {
    const filteredNews = currentCategorySlug !== 'tudo';
    const news = filteredNews ? getState().news.newsFiltered : getState().news.newsPageData;
    const lastUpdated = filteredNews ? getState().news.newsFilteredUpdated : getState().news.newsPageDataUpdated;
    const maxTime = 2 * 60 * 1000; // 2 minutes (mostly to avoid checking for new news right after the page was rendered on the client)

    if (news.length > 0 && lastUpdated && (Date.now() - lastUpdated) > maxTime) {
        dispatch(setIsLoading(true));

        const newsSorted = [...news].sort((a, b) => a.id - b.id).reverse();
        const idLastNews = newsSorted[0].id;
        const query = filteredNews ? `api/v1/news/checkForNewNews/${idLastNews}/${currentCategorySlug}` : `api/v1/news/checkForNewNews/${idLastNews}`;

        return Api.progressGet(dispatch, query)
            .then((json) => {
                dispatch(setIsLoading(false));

                if (json.status !== 'success') {
                    throw `error from server: ${json.message}`;
                } else if (json.data.length > 0) {
                    _scheduleNewNewsPropRemoval(dispatch, getState);

                    return filteredNews ? dispatch(setNewNewsFiltered(json.data)) : dispatch(setNewNews(json.data));
                }

                return false;
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.log('There has been a problem with your fetch operation: ', error);

                return dispatch(setIsLoading(false));
            });
    }

    return Promise.resolve(1);
};

export const setVote = (vote, idNews, callback) => (dispatch, getState) => {
    // pegar o id do usuario e disparar tudo para a controler
    const query = 'api/v1/news/insertVote';
    const userId = getState().profile.user.userId;
    const data = {
        vote,
        id_noticia: idNews,
        id_participante: userId || undefined,
    };

    return Api.progressPost(dispatch, query, data, callback)
        .then((json) => {
            if (json.status === 'success') {
                const like = json.data.qtdLike;
                const dislike = json.data.qtdDislike;

                callback(vote); // this is a small gambiarra to avoid saving this in the store...

                dispatch(updateNewsVotes(idNews, { like, dislike, vote }));
            } else {
                throw `error from server: ${json.message}`;
            }
        }).catch((error) => {
            callback('error');

            throw `setVote got error:${error}`;
        });
};

const _sendViews = (dispatch, getState) => {
    const newsViews = getState().news.newsViews;
    const token = getState().profile.jwt;
    const sessionHash = getState().profile.sessionHash;

    // NOTE: check the load on the server (also on mysql) when using the authenticated route to get the userId.
    // As this means that every view log request results in the decryption of the token and a subsequent database query, this might be heavy
    // If it is too heavy we can omit security and send the userId with the request and skip server side authentication...
    // Good thing is, that there are pretty few users that are constantly logged in :D

    if (newsViews.length < 1) {
        // abort. Not sure when exactly this happens but the array comes empty sometimes when navigating through the page
        return false;
    }

    let query;

    if (token) {
        // logged in user
        query = 'api/v1/tracking/newsViewsHitAuth';
    } else {
        // not logged in user
        query = 'api/v1/tracking/newsViewsHit';
    }

    const data = {
        sendTime: new Date(),
        sessionHash,
        newsViews,
    };

    return Api.progressPost(dispatch, query, data, token)
        .then((json) => {
            if (json.status !== 'success') {
                throw `error from server: ${json.message}`;
            } else {
                return dispatch(resetNewsViews());
            }
        })
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.log('Error sending views, not resetting newsViews ', error);
        });
};
let timerHandle;

export const countNewsView = (newsView) => (dispatch, getState) => {
    // we insert the news into newsViews and send them to the server after 2 seconds,
    // if there is another call before the timer end, the timer will be canceled and a new one started.
    // we do this to reduce the load on the server.

    // update newsViews Array
    dispatch(insertNewsView(newsView));

    // cancel previous timeouts
    clearTimeout(timerHandle);

    // start new timeout and call sendViews
    timerHandle = setTimeout(() => _sendViews(dispatch, getState), 2000);
};
